<ng-content select="[prepend]"></ng-content>
<button mat-icon-button (click)="hierarchyMovement.resetView()" matTooltip="Ansicht zurücksetzen" i18n-matTooltip
  ><mat-icon>center_focus_weak</mat-icon></button
>
<button mat-icon-button (click)="hierarchy.exportImage()" matTooltip="Als Bild exportieren" i18n-matTooltip
  ><mat-icon>photo</mat-icon></button
>
<ng-content></ng-content>

@if (showToolbarContextMenu && focused().length > 0) {
  <div class="context-menu">
    <mat-divider vertical></mat-divider>
    <span data-cy="focused-elements-indicator" i18n
      >{{ focused().length }} {focused().length, plural, =1 {Element} other {Elemente}} ausgewählt</span
    >
    <mat-divider vertical></mat-divider>
    <button
      [disabled]="focused().length > 1"
      mat-icon-button
      (click)="hierarchyNodeState.collapseOneLevel(focused()[0])"
      matTooltip="Schrittweise einklappen"
      i18n-matTooltip
      ><mat-icon>collapse_content</mat-icon></button
    >
    <button
      [disabled]="focused().length > 1"
      mat-icon-button
      (click)="hierarchyNodeState.expandOneLevel(focused()[0])"
      matTooltip="Schrittweise ausklappen"
      i18n-matTooltip
      ><mat-icon>expand_content</mat-icon></button
    >
    @if (toolbarTemplate) {
      <mat-divider vertical></mat-divider>
      <ng-container *ngTemplateOutlet="toolbarTemplate; context: { $implicit: focused() }"></ng-container>
    }
    @if (!hierarchyInterface.readonly) {
      <mat-divider vertical></mat-divider>
      <button
        [disabled]="!canGroup()"
        mat-icon-button
        (click)="hierarchyInterface.group(focused())"
        matTooltip="Elemente gruppieren"
        i18n-matTooltip
        ><mat-icon>group_work</mat-icon></button
      >
      <button
        mat-icon-button
        (click)="hierarchyInterface.deleteMultiple(focused())"
        data-cy="toolbar-delete-button"
        matTooltip="Elemente löschen"
        i18n-matTooltip
        ><mat-icon>delete</mat-icon></button
      >
    }
  </div>
}
